/**
 * scope Normalizr Schema
 */

import { schema } from 'normalizr';

import scope from './scope';

const role = new schema.Entity('roles', {
    scopes: [scope]
});

export default role;
